export default __webpack_public_path__ + "static/media/img-3.ce1607e1.png";